import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Ref. cliente obligatoria por instructivo; espacios solos no cuentan.
 * Antes vivía en `step2-booking-organizaciones.component.ts` (Ref. Cliente era un campo único a
 * nivel de booking); se movió acá junto con el control al pasar a ser por-instructivo
 * (feat-ie-wizard-mejoras, punto 2).
 */
export function customerReferenceRequiredTrim(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const s =
            control.value == null ? '' : String(control.value).trim();
        return s.length === 0 ? { required: true } : null;
    };
}
